'use client'

import { Segmented, SegmentedOptions } from 'shared/antd'

import { CatalogType } from 'modules/Catalog/model/types'
import { CategoryList } from 'modules/Category/features/CategoryList/Mobile'
import { ShopSection } from 'modules/Shop/features/ShopSection/universal'

import { useAppSearchParams } from 'shared/hooks/useAppSearchParams'

import styles from './CatalogBody.module.scss'

const options: SegmentedOptions = [
  {
    label: 'Категории',
    value: CatalogType.CATEGORY,
  },
  {
    label: 'Магазины',
    value: CatalogType.SHOP,
  },
]

const ListComponent = {
  [CatalogType.CATEGORY]: <CategoryList />,
  [CatalogType.SHOP]: <ShopSection />,
}

export function CatalogBody() {
  const { setParam, getParam } = useAppSearchParams()
  const catalogType = getParam('catalogType') || CatalogType.CATEGORY
  const handleTypeChange = (value: CatalogType) => {
    setParam('catalogType', value)
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.segment}>
        <Segmented
          options={options}
          value={catalogType}
          block
          defaultValue={catalogType as CatalogType}
          onChange={value => handleTypeChange(value as CatalogType)}
        />
      </div>
      {ListComponent[catalogType as CatalogType] || null}
    </div>
  )
}
